import { PreviewPDF } from "./UploadPDF";
import styles from "./UploadPDF.module.scss";

type PDFPreviewProps = {
  pdfs: PreviewPDF[];
  onDelete: (pdf: PreviewPDF) => void;
  loading: number;
};

function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export const PDFsPreview: React.FC<PDFPreviewProps> = ({ pdfs, onDelete, loading,  }) => {
  if (!pdfs.length) return null;


  return (
    <ul className={styles.previewList}>
      {pdfs.map((pdf) => (
        <li key={pdf.url} className={styles.previewItem}>
          <span className={styles.pdfIcon}>
            {/* Simple PDF icon via SVG */}
            <svg width="28" height="34" viewBox="0 0 28 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="28" height="34" rx="4" fill="#E53935" />
              <text x="4" y="22" fontFamily="monospace" fontSize="10" fontWeight="bold" fill="white">PDF</text>
            </svg>
          </span>
          <span className={styles.pdfName}>
            <a href={pdf.url} target="_blank" rel="noopener noreferrer" title={pdf.name}>
              {pdf.name}
            </a>
            {pdf.sizeBytes !== undefined && (
              <span className={styles.pdfSize}>{formatBytes(pdf.sizeBytes)}</span>
            )}
          </span>
          {pdf.processing && (
            <span className={styles.progressBar} style={{ width: `${loading}%` }} />
          )}
          <button
            className={styles.deleteButton}
            onClick={() => onDelete(pdf)}
            aria-label={`Delete ${pdf.name}`}
            title="Remove"
            type="button"
          >
            ✕
          </button>
        </li>
      ))}
    </ul>
  );
};
